import { render, staticRenderFns } from "./InvetnBomDiff.vue?vue&type=template&id=2e9ea71b&scoped=true"
import script from "./InvetnBomDiff.vue?vue&type=script&lang=js"
export * from "./InvetnBomDiff.vue?vue&type=script&lang=js"
import style0 from "./InvetnBomDiff.vue?vue&type=style&index=0&id=2e9ea71b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ea71b",
  null
  
)

export default component.exports